import { useWith, identity, includes } from 'ramda';
import { defaultToEmptyArray } from 'ramda-extension';

export const safeIncludes = useWith(includes, [identity, defaultToEmptyArray]);
